import type { COMPARISONS_WORDS_EN } from "./comparisons-words-en.ts";

// The comparisons family's Spanish words (ADR-034 point 1): only this family edits them. What every
// comparison page shares sits here; a page's own words sit in its own two files.
export const COMPARISONS_WORDS_ES: typeof COMPARISONS_WORDS_EN = {
  footerTitle: "Comparar",
  home: "Inicio",
  eyebrow: "Comparar",
  columns: {
    approach: "Enfoque",
    strong: "Dónde destaca",
    check: "Qué revisar",
    job: "El mismo trabajo aquí",
  },
  source: "Fuente:",
  checked: "revisado el {date}",
  questionsTitle: "Preguntas y respuestas",
};
